import React from "react";
import { useStyles } from "./_Generic.style";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-duotone-svg-icons";
import SquareChip from "../../SquareChip"
import { AUDIT_TYPES, AUDIT_SUBTYPES } from "../../../constants";

const GenericAudit = ({ onDrawer, username, action, date, payload , ...props}) => {
  const classes = useStyles();
  const _payload = JSON.parse(props?.history?.payload) ?? null;

  const getTooltip = () => {
    if (AUDIT_TYPES[props?.history?.category] === "License Plate" && AUDIT_SUBTYPES[props?.history?.subcategory] === "Edit" && _payload?.command) {
      const { LprID, OriginalCameraRead, CameraRead } = _payload.command;
      const detail = OriginalCameraRead ? `${OriginalCameraRead} updated to ${CameraRead}` : `updated to ${CameraRead}`;
      return `{"command":{"LprID":${LprID}, ${detail}}}`;
    }
    return JSON.stringify(_payload);
  };

  const handleDetailsClick = () => { 
    onDrawer("generic " + date.toString());
  } 

  return (
    <>
      <tr>
        <td data-column="Area" className={clsx([classes.tdc])}><SquareChip size="small" color="primary" text={AUDIT_TYPES[props?.history?.category]}/></td>
        <td data-column="Date" className={clsx([classes.tdc])}>{date}</td>
        <td data-column="User" className={clsx([classes.tdc])}>
          <div>{username}</div>
        </td>
        <td data-column="Action" className={clsx([classes.tdc])}>
          <div>{AUDIT_SUBTYPES[props?.history?.subcategory]}</div>
        </td>
        <td data-column="Details" className={clsx([classes.tdc,classes.details])}>
          {AUDIT_TYPES[props?.history?.category] === "License Plate" && AUDIT_SUBTYPES[props?.history?.subcategory] === "Edit" && (
           <FontAwesomeIcon onClick={handleDetailsClick} size="lg" className={classes.detailIcon} alt={getTooltip()} title={getTooltip()} icon={faInfoCircle}></FontAwesomeIcon>
           )}
        </td>
      </tr>

    </>
  );
};

export default GenericAudit;
